import { Component, OnInit } from "@angular/core";
import { AdminService } from "../../app/services/admin.service";
import { IUsageStatistics } from "../../app/models/types";
import { TranslateService } from "@ngx-translate/core";
import { LoadingController } from "ionic-angular";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { Subscription } from "rxjs/Subscription";
import { OnDestroy } from "@angular/core/src/metadata/lifecycle_hooks";

interface IStatsItem {
  title: string;
  description?: string;
  value: string | number;
}

interface IStatsCard {
  title: string;
  description?: string;
  statistics: IStatsItem[];
}

@Component({
  selector: "statistics-page",
  templateUrl: "statistics.page.html"
})
export class StatisticsPage implements OnInit, OnDestroy {
  stateSubscription: Subscription;
  state: AppState;
  stats: IUsageStatistics = null;
  statsCards: IStatsCard[] = [];
  constructor(
    private admin: AdminService,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    private store: Store<AppState>
  ) {
    this.stateSubscription = this.store
      .select(state => state)
      .subscribe(state => (this.state = state));
  }

  ngOnInit() {
    const loading = this.loadingCtrl.create({
      content: this.translate.instant(
        _i18n_str("GENERIC_UI.CREATING_NEW_TASK")
      ),
      dismissOnPageChange: true
    });
    loading.present();
    this.admin.getOrgStatistics().subscribe(result => {
      this.stats = result;
      this.statsCards = [
        // Number of users
        {
          title: _i18n_str("STAT_CARDS.USER.TITLE"),
          description: _i18n_str("STAT_CARDS.USER.DESC"),
          statistics: [
            {
              title: _i18n_str("STAT_CARDS.USER.STATS.PATIENT_COUNT.TITLE"),
              value: this.state.patients.length
            },
            {
              title: _i18n_str("STAT_CARDS.USER.STATS.HCP_COUNT.TITLE"),
              value: this.state.hcpUsers.length
            }
          ]
        },
        // Number of PRO answers
        {
          title: _i18n_str("STAT_CARDS.PRO.TITLE"),
          description: _i18n_str("STAT_CARDS.PRO.DESCRIPTION"),
          statistics: [
            {
              title: _i18n_str("STAT_CARDS.PRO.STATS.TOTAL_ANSWER_COUNT.TITLE"),
              value: this.stats.pro.totalQuestionnaireCount
            },
            {
              title: _i18n_str(
                "STAT_CARDS.PRO.STATS.PATIENTS_WITH_NO_ANSWER.TITLE"
              ),
              value: this.stats.pro.patientsWithZero
            },
            {
              title: _i18n_str(
                "STAT_CARDS.PRO.STATS.PATIENTS_WITH_ONE_ANSWER.TITLE"
              ),
              value: this.stats.pro.patientsWithOne
            },
            {
              title: _i18n_str(
                "STAT_CARDS.PRO.STATS.PATIENTS_WITH_TWO_OR_MORE_ANSWER.TITLE"
              ),
              value: this.stats.pro.patientsWithTwoOrMore
            },
            {
              title: _i18n_str("STAT_CARDS.PRO.STATS.ANSWERED_ON_KIOSK.TITLE"),
              value: this.stats.pro.totalOnKiosk
            },
            {
              title: _i18n_str("STAT_CARDS.PRO.STATS.ANSWERED_FROM_HOME.TITLE"),
              value: this.stats.pro.totalFromHome
            }
          ]
        },
        {
          title: _i18n_str("STAT_CARDS.EVAL_STUDY.TITLE"),
          statistics: [
            {
              title: _i18n_str(
                "STAT_CARDS.EVAL_STUDY.STATS.CONSENT_GIVEN_COUNT.TITLE"
              ),
              value: this.stats.evalStudy.consentGiven
            },
            {
              title: _i18n_str(
                "STAT_CARDS.EVAL_STUDY.STATS.CONSENT_DENIED_COUNT.TITLE"
              ),
              value: this.stats.evalStudy.consentDenied
            },
            {
              title: _i18n_str("STAT_CARDS.EVAL_STUDY.STATS.PRO_COUNT.TITLE"),
              value: this.stats.evalStudy.completedQuestionnaires
            },
            {
              title: _i18n_str(
                "STAT_CARDS.EVAL_STUDY.STATS.PATIENT_POST_PRO_EVAL_COUNT.TITLE"
              ),
              value: this.stats.evalStudy.completedPatientPostProEval
            },
            {
              title: _i18n_str(
                "STAT_CARDS.EVAL_STUDY.STATS.PATIENT_POST_VISIT_EVAL_COUNT.TITLE"
              ),
              value: this.stats.evalStudy.completedPatientPostVisitEval
            },
            {
              title: _i18n_str(
                "STAT_CARDS.EVAL_STUDY.STATS.HCP_POST_VISIT_EVAL_COUNT.TITLE"
              ),
              value: this.stats.evalStudy.completedHcpPostVisitEval
            }
          ]
        }
      ];
      setTimeout(() => {
        loading.dismiss();
      }, 1000);
    });
  }

  ngOnDestroy() {
    this.stateSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/statistics.page/statistics.page.ts